import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'SAFRA_MANEJO_TIPO_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro
			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('safraManejoTipoForm', {
			...registro,
			produto_tipos: registro.produto_tipos || []
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'SAFRA_MANEJO_TIPO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/safraManejoTipo`);
    return {
        type: 'SAFRA_MANEJO_TIPO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
			console.log(registro)
	        axios.post(`${consts.API_URL}/safraManejoTipo`, {
				...registro,
                
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			console.log(registro)
			axios.put(`${consts.API_URL}/safraManejoTipo`, {
				...registro
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/safraManejoTipo?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaProdutoTipo() {
    const request = axios.get(`${consts.API_URL}/produtoTipo/listarSelect`);
    return {
        type: 'SAFRA_MANEJO_TIPO_LISTADO_PRODUTO',
        payload: request
    };
}
